<template>
  <div class="base-table-page" :class="{ reHeight: getProps.showPagination }">
    {{ $attrs.footerData }}
    <vxe-table
      ref="tableRef"
      border="none"
      class="custom-table"
      auto-resize
      header-cell-class-name="custom-header"
      showOverflow
      :column-config="{ resizable: getProps.resizeAble }"
      :loading="loading"
      :data="getBindValues.data"
      :checkbox-config="checkboxConfig"
      :scroll-y="{ enabled: true, gt: 50 }"
      :row-config="{ keyField: getProps.rowKey, useKey: true }"
      v-bind="$attrs"
      :sort-config="sortConfig"
      @sortChange="sortChangeFn"
      @scroll="handleScroll"
      @resizable-change="($event: any) => resizableChange($event, refreshColumns)"
    >
      <!-- ResizableChange -->
      <vxe-column
        type="checkbox"
        fixed="left"
        :width="getFieldWidthValue('customCheck') || 60"
        min-width="60"
        field="customCheck"
        :resizable="false"
        v-if="getProps.showSelection && getBindValues.columns.length > 0"
      >
        <template #header="{ checked, indeterminate, disabled }">
          <div class="batchSelect">
            <el-checkbox
              v-if="getProps.showSelectionAll"
              :disabled="disabled"
              :modelValue="checked"
              :indeterminate="indeterminate"
              @change="(checked: boolean) => toggleAllCheckboxEvent(checked, indeterminate)"
            />
            <!-- 批量筛选 -->
            <TableBatchSelect
              v-if="getProps.showbatchSelect"
              @registerTableBatchSelect="registerTableBatchSelect"
              :tableTotal="total"
              :maxSelections="maxSelections"
              @tableBatchSelectSure="tableBatchSelectSure"
            />
          </div>
        </template>
        <template #checkbox="{ row, checked, indeterminate, disabled }">
          <el-checkbox
            v-if="!handleHideRowCheckbox(row)"
            :disabled="isRowDisabled(row) || disabled"
            :modelValue="checked"
            @change="toggleCheckboxEvent(row)"
          />
        </template>
      </vxe-column>

      <vxe-column
        type="radio"
        fixed="left"
        :width="getFieldWidthValue('customSingle') || 60"
        min-width="60"
        :resizable="false"
        field="customSingle"
        v-if="getProps.showSingleSelection && getBindValues.columns.length > 0"
      >
        <template #radio="{ row, checked, $rowIndex }">
          <div class="custom-radio">
            <span
              :class="{ overlay: true, disabled: isRowDisabled(row) }"
              @click.stop="handleChangeRadio(row, $rowIndex)"
            />
            <span
              :class="{
                circle: true,
                'focus-circle': checked || isRowDisabled(row),
                disabled: isRowDisabled(row)
              }"
            />
          </div>
        </template>
      </vxe-column>

      <vxe-column
        type="seq"
        fixed="left"
        title="序号"
        :width="70"
        min-width="60"
        field="customSeq"
        :resizable="false"
        style="display: none"
        v-if="getProps.showRowIndex && getBindValues.columns.length > 0"
      />
      <!-- :show-header-overflow="i.key === 'operate' && getProps.showSetting ? false : true" -->

      <template v-for="i in getBindValues.columns" :key="i.key">
        <vxe-column
          v-if="i.cellRender"
          v-bind="getColumnBindingValue(i)"
          :cell-render="i.cellRender"
        ></vxe-column>
        <vxe-column
          v-else
          v-bind="getColumnBindingValue(i)"
          :tree-node="i.type === 'treenode'"
          :show-header-overflow="i.key === 'operate' && getProps.showSetting ? false : true"
          :resizable="i.key !== 'operate'"
        >
          <template #header>
            <template v-if="i.headerSlot">
              <slot :name="i.headerSlot" :column="i" />
            </template>
            <template v-else-if="i.headerTooltipText">
              <div class="header-content">
                <RxkSingeLineTooltip
                  class="title-text"
                  effect="dark"
                  :tooltipContent="i.title"
                  placement="top"
                />

                <el-tooltip effect="dark" :content="i.headerTooltipText" placement="top">
                  <i class="iconfont icon-warning desc-icon" />
                </el-tooltip>
              </div>
            </template>
            <template v-else-if="i.key === 'operate' && getProps.showSetting">
              <div class="operate">
                <span>{{ i.title }}</span>
                <!-- 单独处理表头设置的提示 -->
                <el-tooltip content="表头设置" placement="top">
                  <span class="setting-btn" @click="showSetting">
                    <span class="iconfont icon icon-libiaopeizhi" />
                  </span>
                </el-tooltip>
                <!-- <span class="setting-btn" @click="showSetting">
                  <span class="iconfont icon icon-libiaopeizhi" />
                </span> -->
              </div>
            </template>
            <template v-else>
              {{ i.title }}
            </template>
          </template>

          <template v-if="i.render" v-slot="scope">
            <TableColumnRender
              :data="scope.row"
              :column-config="i"
              :render-fn="i.render"
              :rowIndex="scope.rowIndex"
            />
          </template>
          <template v-else-if="i.slot" v-slot="{ row, $rowIndex }">
            <slot :name="i.slot" :row="row" :index="$rowIndex" :column="i" />
          </template>
          <template v-else-if="i.text" v-slot="{ row, $rowIndex }">
            {{ dealShowVal(i.text(row)) }}
          </template>
          <template v-else v-slot="scope">
            {{ getProps.noDealData ? scope.row[i.key] : dealShowVal(scope.row[i.key]) }}
          </template>
          <template #footer="{ row, columnIndex }" v-if="$slots.footers">
            <slot name="footers" :row="row" :columnIndex="columnIndex"></slot>
          </template>
        </vxe-column>
      </template>
    </vxe-table>
  </div>
  <div class="pagination-box tw-items-center">
    <div>
      <slot name="leftSlot" />
    </div>
    <el-pagination
      v-if="getProps.showPagination"
      class="custom-pagination"
      :current-page="getPaginationInfo.pageNum"
      :page-size="getPaginationInfo.pageSize"
      :page-sizes="pageSizes"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @size-change="handleSizeChangeFn"
      @current-change="handleCurrentChangeFn"
    />
  </div>
</template>
<script lang="ts" setup>
import './style.scss'
import { computed, unref, ref, watch, nextTick, useAttrs, getCurrentInstance } from 'vue'
import TableColumnRender from './TableColumnRender.vue'
import { useTableData } from './hooks/useTableData'
import type { BasicTableProps } from './type'
import { useColumns } from './hooks/useColumns'
import type { TableActionType } from './type'
import { usePagination } from './hooks/usePagination'
import { isEmptyArray, isNullOrUnDef, isNullOrUndefOrEmpty } from '@/utils/is'
import { ColumnType } from '@/types/table'
import { useSection } from './hooks/useSection'
import { TableData } from './type'
import TableBatchSelect from './TableBatchSelect.vue'
import { useResizeColumn } from './hooks/useResizeColumn'
import { useTableBatchSelect, type BatchData } from './hooks/useTableBatchSelect'
import { useResource } from '@/hooks/useResource'
import { size, isArray, isNil } from 'lodash-es'
import RxkSingeLineTooltip from '@/components/common/RxkSingeLineTooltip'
import { deepMergeReplace } from '@/utils/tools'
import { usePageCache } from '@/hooks/usePageCache'
const attrs = useAttrs()
const maxSelections = 10000
const tipsNum = ref(0)
// 复选框配置项
const checkboxConfig = {
  reserve: true,
  checkField: 'customizeSelectedFields',
  checkMethod: ({ row }) => {
    const len = sectionList.value.length
    if (len && len > maxSelections) {
      nextTick(() => {
        if (tipsNum.value === 0 && len > maxSelections) {
          ElMessage({
            type: 'error',
            message: `批量操作已达最大数量${maxSelections}`,
            grouping: true
          })
          tipsNum.value++
        }
      })
      return !!getSectionDataIds().includes(row[getProps.value?.rowKey || 'id'])
    } else {
      tipsNum.value = 0
      return true
    }
  }
}
// 禁选事件
const isRowDisabled = (row: any) => {
  return attrs?.disabledFn?.(row) || false
}
// 隐藏行复选框
const handleHideRowCheckbox = (row: any) => {
  return attrs?.hideRowCheckbox?.(row) || false
}
const tableRef = ref()
const emit = defineEmits([
  'register',
  'selectionChange',
  'getTableData',
  'showSetting',
  'sortChange',
  'pageChange',
  'event-select'
])
function sortChangeFn(column: Recordable) {
  // 点击时只筛选当前列 需求编号2000529
  const { order, field } = column
  sortConfig.value.multiple = false
  column.sortList = order ? [column] : []
  tableRef.value.sort(field, order)
  emit('sortChange', column)
}
const innerPropsRef = ref<Partial<BasicTableProps>>()
const searchInfo = ref({})
const tableTotal = ref(-1)
const sortConfig = ref<Recordable>({ remote: true, multiple: true })

const getProps = computed(() => {
  return {
    showPagination: true,
    showRowIndex: true,
    showSelectionAll: true,
    resizeAble: true,
    customTableConfig: true,
    ...unref(innerPropsRef),
    // searchInfo: { ...unref(searchInfo), ...unref(innerPropsRef)?.searchInfo },
    searchInfo: deepMergeReplace({ ...unref(innerPropsRef)?.searchInfo }, { ...unref(searchInfo) }),
    rowKey: 'id',
    tableTotal: unref(tableTotal)
  } as BasicTableProps
})

// 分页hooks
const { getPaginationInfo, handleSizeChange, handleCurrentChange, setPaginationInfo, pageSizes } =
  usePagination(getProps)
// 表格数据hooks
const {
  tableData,
  reload,
  total,
  loading,
  batchSelectFetch,
  batchSelectData,
  initTableCache,
  getPagination
} = useTableData(getProps, {
  getPaginationInfo,
  emit,
  tableRef,
  batchTableSelectCheck,
  clearSelection,
  setPaginationInfo
})

const { resizableChange, mergeColumnWidth, getFieldWidthValue } = useResizeColumn(getProps, loading)

// 批量筛选hooks
const [registerTableBatchSelect, { getBatchSelectPageInfo, initBatchData }] = useTableBatchSelect({
  startLimit: 1,
  endLimit: 10000
})

// 表头hooks
const { getColumns } = useColumns(getProps)
// 选择项hooks
const { selectionChange, sectionList } = useSection()
const getBindValues = computed(() => {
  const data = unref(tableData)
  // console.log(getColumns, 'getColumns123', data)
  return {
    data,
    columns: unref(getColumns)
  }
})

function getColumnBindingValue(i: ColumnType) {
  const {
    fixed,
    title,
    key,
    width,
    minWidth,
    sortable,
    showOverflow,
    filterOptions,
    filterRender
  } = i
  const data: Recordable = {
    title,
    prop: key,
    field: key,
    minWidth: minWidth || 80,
    'show-header-overflow': true
  }
  fixed && (data.fixed = fixed)
  width && (data.width = width)
  sortable && (data.sortable = sortable)
  if (!isNil(showOverflow)) {
    data['show-overflow'] = showOverflow
  }
  // 自定义筛选 不请求后端
  if (filterOptions && isArray(filterOptions) && size(filterOptions)) {
    data.filters = filterOptions
  }
  if (!isNullOrUndefOrEmpty(filterRender)) data.filterRender = filterRender
  return data
}

function setProps(props: Partial<BasicTableProps>) {
  // console.log(props, 'propszzzz', innerPropsRef)
  // 处理表格数据更新重新加载
  const $table = tableRef.value
  // if ($table) {
  //   refreshColumns()
  // }
  innerPropsRef.value = { ...unref(innerPropsRef), ...props }
  // 后置合并column
  props.columns && mergeColumnWidth(innerPropsRef.value.columns)
  if (props.data) {
    if ($table) {
      $table.loadData(props.data)
    }
  }
  if (props!.tableTotal || props!.tableTotal === 0) {
    setTotal(props.tableTotal)
  }
}

function refreshColumns() {
  let a = tableRef.value.getColumns()
  let b = getBindValues.value.columns

  // 定义一个函数，用于获取字段在b数组中的索引
  function getFieldIndex(field: string) {
    return b.findIndex(item => item.key === field)
  }

  // // 使用sort方法和自定义比较函数对a数组进行排序
  a.sort((item1: any, item2: any) => {
    return getFieldIndex(item1.field) - getFieldIndex(item2.field)
  })
  mergeColumnWidth(a)
  // console.log('refreshColumns', a)

  tableRef.value.loadColumn(a)
}
// 设置请求参数
function setSearchInfo(data: Recordable) {
  searchInfo.value = { ...data }
  if (!isNullOrUnDef(data?.orderBy?.orders) && !isEmptyArray(data?.orderBy?.orders)) {
    setSortConfig({
      defaultSort: data?.orderBy?.orders?.map((ele: { expression: string; field: string }) => ({
        order: ele.expression,
        field: ele.field
      }))
    })
  }
}
function setTotal(totalNum: number) {
  tableTotal.value = totalNum
  total.value = totalNum
}
function getSearchInfo() {
  return JSON.parse(JSON.stringify(unref(getProps).searchInfo))
}
// 获取已选中项
function getSectionData(): Recordable[] {
  return JSON.parse(JSON.stringify(unref(sectionList)))
}

// 获取已选中项ID
function getSectionDataIds(): Recordable[] {
  const ids: any[] = []
  sectionList.value.forEach(item => {
    ids.push(item.id)
  })
  return ids
}

// 清空所有选中
function clearSelection() {
  const $table = tableRef.value
  if ($table) {
    $table.clearCheckboxRow()
    $table.clearCheckboxReserve()
    selectionChange([])
    emit('selectionChange')
    initBatchData({
      startLimit: 1,
      endLimit: 10000
    })
  }
}
/**
 * @description 获取表格数据
 * @param {boolean} [isReactive = false] - 是否返回响应式数据
 */
function getTableData(isReactive = false): TableData {
  return {
    total: unref(total),
    list: isReactive ? tableData : JSON.parse(JSON.stringify(unref(tableData)))
  }
}

// 复选框表头全选
function toggleAllCheckboxEvent(checked: boolean, indeterminate: boolean) {
  // console.log(checked, indeterminate)
  const $table = tableRef.value
  // 是否超过最大值
  const records = $table.getCheckboxRecords()
  const reserveRecords = $table.getCheckboxReserveRecords()
  const selectedRows = records.concat(reserveRecords).concat(getBindValues.value.data)
  const len = selectedRows.length
  const uniqueSelectedRows = Array.from(new Set(selectedRows))
  // console.log(len, maxSelections, 11111111111)

  if (len > maxSelections) {
    // 如果已选中的行数量超过最大值
    const slicedRows = uniqueSelectedRows.slice(0, maxSelections) // 截取前maxSelections个选中的行
    if (checked) {
      // 设置选中的行为截取后的行
      $table.setCheckboxRow(slicedRows, checked)
    } else {
      if (indeterminate) {
        $table.setCheckboxRow(slicedRows, indeterminate)
      } else {
        // 取消当前页的全选数据
        $table.toggleAllCheckboxRow()
      }
    }
  } else {
    // 获取可见表格数据
    const { visibleData } = $table.getTableData()
    // disabled不能取消勾选
    const selectRows = visibleData.filter((row: Recordable) => {
      return !isRowDisabled(row)
    })
    if (size(selectRows) && Reflect.has(attrs, 'preventDefault')) {
      $table.setCheckboxRow(selectRows, checked)
      return
    }

    if (Reflect.has(attrs, 'customCheckDeal')) {
      $table.setCheckboxRow(selectRows, checked)
      setSelectionData()
      return
    }

    // 执行全选/取消全选操作
    $table.toggleAllCheckboxRow()
  }
  setSelectionData()
}

// 复选框选中
function toggleCheckboxEvent(row: Recordable) {
  const $table = tableRef.value
  if ($table) {
    $table.toggleCheckboxRow(row)
    setSelectionData()
  }
  emit('event-select', row)
}

function setSelectionData() {
  const $table = tableRef.value
  const records = $table.getCheckboxRecords()
  const reserveRecords = $table.getCheckboxReserveRecords()
  selectionChange(records.concat(reserveRecords))
  emit('selectionChange')
}

function setSortConfig(data: Recordable) {
  sortConfig.value = { ...sortConfig.value, ...data }
  // console.log(sortConfig, 'sortConfig123')
}
const radioRowData = ref({})
const radioRowIndex = ref(0)
function getRadioData() {
  return { rowData: { ...radioRowData.value }, rowIndex: radioRowIndex.value }
}

const tableAction: TableActionType = {
  setProps,
  setSearchInfo,
  reload,
  getSectionData,
  getTableData,
  clearSelection,
  getSearchInfo,
  getSectionDataIds,
  setSortConfig,
  getRadioData,
  getPaginationInfo,
  initTableCache,
  setTotal,
  setPaginationInfo,
  getPagination
}
emit('register', tableAction)
async function handleSizeChangeFn(val: number) {
  await handleSizeChange(val)
  reload()
  emit('pageChange', val, 'size')
  batchTableSelectCheck(sectionList.value || [])
}
function handleCurrentChangeFn(val: number) {
  if (tableTotal.value === -1) {
    handleCurrentChange(val)
    reload()
  }
  emit('pageChange', val, 'num')
  batchTableSelectCheck(sectionList.value || [])
}
function dealShowVal(val: any) {
  if (isNullOrUndefOrEmpty(val)) {
    return '-'
  }
  return val
}

function showSetting() {
  emit('showSetting')
}

// 批量选择确定获取ID
async function tableBatchSelectSure(batchData: BatchData) {
  const $table = tableRef.value
  $table.clearCheckboxRow()
  selectionChange([])
  await batchSelectFetch({
    customerReq: {
      ...batchData,
      ...(getSearchInfo()?.customerReq || {})
    }
  })
  // 定位到起始页
  const batchSelectPageInfo = getBatchSelectPageInfo(batchData, getPaginationInfo.value.pageSize)
  if (getPaginationInfo.value.pageNum !== batchSelectPageInfo?.tableBatchStartPage) {
    handleCurrentChangeFn(batchSelectPageInfo?.tableBatchStartPage)
  }
  const records: Recordable[] = []
  batchSelectData.value.map(item => {
    records.push({
      id: item.id
    })
  })
  // console.log(records, 'recordsrecords')
  // // 处理表格数据选中
  batchTableSelectCheck(records)
}

// 处理批量筛选表格选中
function batchTableSelectCheck(row: Recordable) {
  // console.log(row, '表格选中')
  const $table = tableRef.value
  if ($table) {
    // $table.clearCheckboxRow()
    // selectionChange([])
    $table.setCheckboxRow(row, true)
    selectionChange(row)
    emit('selectionChange')
    $table.loadData(getBindValues.value.data)
  }
}
// const refreshVisible = ref(true)
watch(
  () => getBindValues.value.columns,
  () => {
    // console.log('变了123')
    // refreshVisible.value = false
    nextTick(() => {
      // refreshVisible.value = true
      refreshColumns()
      // 处理表格选中回显
      if (sectionList.value && sectionList.value.length > 0) {
        setTimeout(() => {
          batchTableSelectCheck(sectionList.value)
        }, 0)
      }
    })
  }
)

defineExpose({ tableRef, batchTableSelectCheck })
function handleChangeRadio(row: Recordable, index: any) {
  const $table = tableRef.value
  if ($table) {
    $table.setRadioRow(row)
    radioRowData.value = row
    radioRowIndex.value = index
  }
}

// 滚动
function handleScroll(e: Recordable) {
  const { updateCache } = usePageCache()
  // usePageCache:缓存滚动
  updateCache({ table: { scrollX: e.scrollLeft, scrollY: e.scrollTop } })
}
</script>
<style lang="scss" scoped>
.custom-table {
  :deep(.vxe-table--render-default) {
    .is--disabled.vxe-cell--checkbox {
      .vxe-checkbox--icon {
        background-color: #edf2fc;
      }
    }
  }
  //:deep(.vxe-body--row .vxe-body--column:last-child){
  //  border-right: none;
  //}
  :deep(.vxe-table--fixed-right-wrapper) {
    background: #fff;
  }
  :deep(.vxe-table--fixed-left-wrapper) {
    background: #fff;
  }
}
.operate {
  display: flex;
  position: relative;
  .setting-btn {
    position: absolute;
    right: -10px;
    top: -10px;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-left: 1px solid #ebeef5;
    cursor: pointer;
    .icon {
      font-size: 16px;
      color: #666666;
    }
  }
}

.header-content {
  @include flex-center(row, normal);
  .title-text {
    font-size: 14px;
    font-weight: 700;
    font-style: normal;
    display: inline-block;
    max-width: calc(100% - 16px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 22px;
  }
  .desc-icon {
    font-size: 14px;
    color: #999999;
    flex-shrink: 0;
    margin-left: 8px;
    cursor: pointer;
  }
}

.batchSelect {
  @include flex-center(row, space-between, center);
}
.custom-radio {
  position: relative;
  .overlay {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    z-index: 2;
    &.disabled {
      pointer-events: none;
    }
  }
  .circle {
    display: inline-block;
    width: 14px;
    height: 14px;
    border: 1px solid #dcdfe6;
    border-radius: 50%;
    &.focus-circle {
      border: 5px solid #5687ff;
      &.disabled {
        border: 5px solid #ccc;
      }
    }
  }
}
</style>
